import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MaterialSymbol } from 'material-symbols';
import { FlexAlignDirective } from '../../directives/alignment/flex-align.directive';
import { FlexDirectionDirective } from '../../directives/alignment/flex-direction.directive';
import { FlexFillDirective } from '../../directives/alignment/flex-fill.directive';
import { ClickableDirective } from '../../directives/clickable.directive';
import { FlexGapDirective } from '../../directives/spacing/flex-gap.directive';
import { PaddingDirective } from '../../directives/spacing/padding.directive';
import { InlineBannerDirective } from '../inline-banner/inline-banner.directive';
import { GlobalInlineBannerStateService } from './global-inline-banner-state.service';

@Component({
  selector: 'app-global-inline-banner',
  imports: [
    InlineBannerDirective,
    MatIcon,
    MatButton,
    PaddingDirective,
    FlexDirectionDirective,
    FlexGapDirective,
    FlexAlignDirective,
    FlexFillDirective,
    FlexFillDirective,
    ClickableDirective
  ],
  templateUrl: './global-inline-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GlobalInlineBannerComponent {
  private readonly globalBannerStateService = inject(GlobalInlineBannerStateService);

  $banner = this.globalBannerStateService.banner;

  protected readonly closeIcon: MaterialSymbol = 'close';

  closeBanner() {
    this.globalBannerStateService.closeBanner();
  }
}
